import { render, staticRenderFns } from "./productcoupon_management_detail.vue?vue&type=template&id=a61141c8&scoped=true&"
import script from "./productcoupon_management_detail.vue?vue&type=script&lang=js&"
export * from "./productcoupon_management_detail.vue?vue&type=script&lang=js&"
import style0 from "./productcoupon_management_detail.vue?vue&type=style&index=0&id=a61141c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61141c8",
  null
  
)

export default component.exports